import React, { useContext, useState } from 'react';
import { useIsMobileView, useTranslation } from '@front10/utils';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import Fuse from 'fuse.js';
import { EmotionCache } from '../../containers/_commons/emotionCache';
import Box from '../../elements/Box';
import { FlexibleFilterContainer } from '../../lab/FlexibleFilterContainer';
import { default as TravelerInterestBase } from '../InlineFilters/TravelerInterest';
import { FilterButton } from '../../lab/FilterButton';
import Button from '../../elements/Button';
import Text from '../../elements/Text';
import Checkbox from '../InlineFilters/CheckboxItem';
import Input from '../../elements/Input';
import LocationSelectorNoResult from '../LocationSelector/LocationSelectorNoResult';
import { useImperativeHandle } from 'react';

function filterContainsPrepopulatedOptions(options) {
  return Array.isArray(options) && options.length > 0 && options[0]?.label === undefined;
}
function updatePrepopulatedOptions({
  selectedItemsState,
  data,
  travelInterestId,
  itemAllEelements
}) {
  let selectedOptions = [];
  selectedOptions = data[travelInterestId].options.filter((option) =>
    selectedItemsState.some((opt) => opt.value === option.value)
  );
  if (
    data[travelInterestId].options.length === selectedItemsState.length ||
    selectedItemsState.find((obj) => obj.value === 'any')
  ) {
    selectedOptions.unshift(itemAllEelements);
  }
  return selectedOptions;
}

const TravelerInterestCmp = (props, ref) => {
  const {
    isMobile: propIsMobile,
    disabled,
    travelersInterest: { data = {} },
    onChange,
    onClear,
    selectedItems: selectedItemsState,
    travelInterestId,
    titleLabelKey = 'cmp-traveler-interests-title',
    noResultLabelKey = 'cmp-traveler-interest-no-result',
    labelKey = 'cmp-traveler-interests-label',
    doneButtonLabelKey = 'cmp-traveler-interests-done-button',
    clearButtonLabelKey = 'cmp-traveler-interests-clear-button',
    listItem,
    allItems,
    mapperIcons,
    defaultIcon,
    containerSettings,
    clearButtonSettings,
    doneButtonSettings,
    enableSearchQuantityItems = 10,
    footerContainer = {},
    buttonsContainer = {},
    noResultItem = {},
    menuContainer = {
      'cmp-styles': {
        height: '100%'
      }
    },
    optionsContainer = {
      'cmp-styles': {
        overflow: 'scroll',
        height: '100%'
      }
    },
    separatorStyle = {
      'cmp-styles': {
        'border-top': '1px solid rgba(0,0,0,.125)'
      }
    },
    selectedStyle = {
      'cmp-styles': {
        'font-weight': '300',
        'padding-left': '3px'
      }
    },
    countSelectedStyle = {
      'cmp-styles': {
        'font-weight': 'bold!important'
      }
    },
    customMobileScreenWidth = []
  } = props;
  const {
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const translate = useTranslation();
  const contextTranslate = useContext(Context).translate;

  const { alwaysEnabledDoneButton = true } = doneButtonSettings;
  const title = contextTranslate(titleLabelKey, 'Travel interests');
  const label = contextTranslate(labelKey, 'Select interests');

  const active = Boolean(selectedItemsState[travelInterestId]?.selectedItems.length > 0);

  let isMobile = useIsMobileView({ customMobileScreenWidth });
  if (propIsMobile) {
    isMobile = propIsMobile;
  }
  //INFO: Adjusting props for desktop
  const newProps = {
    ...props,
    isMobile,
    inputItem: {
      ...props.inputItem,
      labelSeparator: contextTranslate(props.labelKeySeparatorMultiSelection, ', '),
      ToggleElement: FilterButton,
      value: label,
      disabled,
      count: true,
      active: active,
      'aria-haspopup': 'dialog'
    }
  };
  const travelerInterestBaseRef = React.useRef(null);

  const desktop = <TravelerInterestBase ref={travelerInterestBaseRef} {...newProps} />;

  //MOBILE VIEW
  //INFO: For mobile view is necessary make a custom render to avoid the button render
  const ITEM_WEIGHT_ELEMENTS = -1;
  const ITEM_ANY_ELEMENTS = 'any';
  const flexibleFilterContainerRef = React.useRef(null);
  const doneButtonRef = React.useRef();
  const [activateDoneButton, setActivateDoneButton] = useState(false);
  const [itemSelectedByKeyboard, setItemSelectedByKeyboard] = useState(null);

  const handleClosePopup = (e) => {
    // user keypress Esc inside a item
    if (e.keyCode === 27) {
      travelerInterestBaseRef.current?.closePopup();
    }
  };

  function renderItem(item, line) {
    return inputValue === '' ? (
      <>
        <Checkbox
          {...props}
          {...listItem}
          icon={mapperIcons[item.value] ? mapperIcons[item.value] : defaultIcon}
          allItems={item.weight === ITEM_WEIGHT_ELEMENTS ? allItems : {}}
          isMobile={isMobile}
          item={item}
          isChecked={selectedItems.find((x) => x.value === item.value)}
          showSideMessage={false}
          onChange={(_, itemMarked) => {
            if (isMobile) {
              if (itemMarked.value === ITEM_ANY_ELEMENTS) {
                setActivateDoneButton(true);
              } else {
                if (
                  selectedItems.find((x) => x.value === item.value) !== undefined &&
                  selectItem.length === 1
                ) {
                  setActivateDoneButton(true);
                }
              }
              const newSelectedItems = selectItem(itemMarked);
              setSelectedItems(newSelectedItems);
            }
          }}
          onKeyUp={handleClosePopup}
          enableFocus
          setFocusOnItem={
            itemSelectedByKeyboard !== null && item.label === itemSelectedByKeyboard?.label
          }
        />
        {line && <Box {...separatorStyle} />}
      </>
    ) : (
      <>
        <Checkbox
          {...props}
          {...listItem}
          icon={mapperIcons[item.value] ? mapperIcons[item.value] : defaultIcon}
          allItems={item.weight === ITEM_WEIGHT_ELEMENTS ? allItems : {}}
          isMobile={isMobile}
          item={item}
          isChecked={selectedItems.find((x) => x.value === item.value)}
          showSideMessage={false}
          onChange={(_, itemMarked) => {
            if (isMobile) {
              if (itemMarked.value === ITEM_ANY_ELEMENTS) {
                setActivateDoneButton(true);
              } else {
                if (
                  selectedItems.find((x) => x.value === item.value) !== undefined &&
                  selectItem.length === 1
                ) {
                  setActivateDoneButton(true);
                }
              }
              const newSelectedItems = selectItem(itemMarked);
              setSelectedItems(newSelectedItems);
              if (inputValue !== '') {
                setValue('');
                setItemSelectedByKeyboard(item);
              }
            }
          }}
          enableFocus
          setFocusOnItem={
            itemSelectedByKeyboard !== null && item.label === itemSelectedByKeyboard?.label
          }
        />
        {line && <Box {...separatorStyle} />}
      </>
    );
  }

  //TODO: Duplicate function
  //src/components/controls/InlineFilters/TravelerInterest.tsx
  const handleClear = () => {
    setSelectedItems([]);
    doneButtonRef.current?.focus();
    // let payload: any = {};
    // payload[data[travelInterestId].id] = undefined;
    // onClear(data[travelInterestId].id);
    setActivateDoneButton(true);
    if (inputValue !== '') {
      setValue('');
    }
  };

  //TODO: Duplicate function
  //src/components/controls/InlineFilters/TravelerInterest.tsx
  const handleSave = () => {
    let payload = {};
    const value = Object.assign({}, { ...data[travelInterestId], selectedItems });
    delete value.id;
    delete value.options;
    payload[data[travelInterestId].id] = value;
    if (payload[data[travelInterestId].id].selectedItems.length === 0) {
      onClear(data[travelInterestId].id);
    } else {
      onChange(payload);
    }

    flexibleFilterContainerRef.current?.save();
    setActivateDoneButton(false);
    if (inputValue !== '') {
      setValue('');
    }
    if (itemSelectedByKeyboard) {
      setItemSelectedByKeyboard(null);
    }
  };

  //TODO: Duplicate function
  //src/components/controls/InlineFilters/TravelerInterest.tsx
  const renderFooter = () => (
    <Box display="flex" {...footerContainer}>
      <div aria-live="polite" aria-atomic="true">
        {selectedItems.length !== 0 && (
          <>
            <Text dataTestId="traveler-interest-filter-counter" {...countSelectedStyle}>
              {selectedItems[0].value === 'any' ? selectedItems.length - 1 : selectedItems.length}
            </Text>
            <Text {...selectedStyle}>
              {translate('cmp-traveler-info-options-selected', ' selected')}
            </Text>
          </>
        )}
      </div>

      <Box {...buttonsContainer}>
        <Button
          color="light"
          {...clearButtonSettings}
          disabled={selectedItems.length === 0}
          onClick={handleClear}
        >
          {contextTranslate(clearButtonLabelKey, 'Clear')}
        </Button>
        <Button
          color="primary"
          focusReferences={doneButtonRef}
          {...doneButtonSettings}
          disabled={
            alwaysEnabledDoneButton ? false : selectedItems.length === 0 && !activateDoneButton
          }
          onClick={handleSave}
        >
          {contextTranslate(doneButtonLabelKey, 'Done')}
        </Button>
      </Box>
    </Box>
  );

  //TODO: Duplicate function
  //src/components/controls/InlineFilters/TravelerInterest.tsx
  const selectItem = (itemMarked) => {
    if (itemMarked.value === ITEM_ANY_ELEMENTS) {
      if (selectedItems.length === options.length) {
        return [];
      } else {
        return options;
      }
    } else {
      if (selectedItems.length === 0) {
        return [itemMarked];
      } else {
        const index = selectedItems.findIndex((item) => item.value === itemMarked.value);
        if (index !== -1 && itemMarked.value !== ITEM_ANY_ELEMENTS) {
          // const optionsWithoutAllItems = selectedItems.filter(
          //   (e) => e.value !== ITEM_ANY_ELEMENTS
          // );

          // } else {
          let aux = [...selectedItems];
          aux.splice(index, 1);
          const index1 = aux.findIndex((item) => item.value === ITEM_ALL_ELEMENTS.value);
          if (index1 !== -1) {
            aux.splice(index1, 1);
          }
          return aux;
          // }
        } else {
          if (itemMarked.value === ITEM_ANY_ELEMENTS) {
            return options;
          } else {
            let tmp = [...selectedItems];
            tmp.push(itemMarked);
            if (tmp.length === options.length - 1) {
              return options;
            }
            return tmp;
          }
        }
      }
    }
  };

  const [selectedItems, setSelectedItems] = React.useState(() => {
    if (Boolean(selectedItemsState[travelInterestId])) {
      return selectedItemsState[travelInterestId].selectedItems;
    } else {
      return [];
    }
  });

  const [inputValue, setValue] = React.useState('');

  useImperativeHandle(ref, () => ({
    clearInput: () => {
      setValue('');
    }
  }));

  const ITEM_ALL_ELEMENTS = React.useMemo(() => {
    return {
      label: contextTranslate('cmp-traveler-interest-any', 'Any interests'),
      weight: ITEM_WEIGHT_ELEMENTS,
      value: ITEM_ANY_ELEMENTS
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ITEM_WEIGHT_ELEMENTS, translate]);

  const options = React.useMemo(() => {
    if (data && data[travelInterestId]) {
      const opts = data[travelInterestId].options;
      return Boolean(inputValue) ? opts : [ITEM_ALL_ELEMENTS, ...opts];
    }
    return [];
  }, [ITEM_ALL_ELEMENTS, data, travelInterestId, inputValue]);

  React.useEffect(() => {
    if (!selectedItemsState[travelInterestId]) {
      setSelectedItems([]);
    } else {
      const newSelectedItemsState = selectedItemsState[travelInterestId].selectedItems;
      if (filterContainsPrepopulatedOptions(newSelectedItemsState)) {
        if (data && data[travelInterestId]) {
          const selectedOptions = updatePrepopulatedOptions({
            selectedItemsState: newSelectedItemsState,
            data,
            travelInterestId,
            itemAllEelements: ITEM_ALL_ELEMENTS
          });
          setSelectedItems(selectedOptions);
        }
      } else {
        setSelectedItems(newSelectedItemsState);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemsState]);

  const buttonLabel = React.useMemo(() => {
    if (selectedItems.length === 0) {
      return contextTranslate('cmp-traveler-interests-title', 'Select interest');
    }
    if (selectedItems.length === options.length) {
      return contextTranslate('cmp-filter-all-items-selected', 'All items selected');
    } else {
      return contextTranslate('cmp-traveler-interests-title', 'Select interest').concat(
        ' ',
        selectedItems
          .map((i) => i.label)
          .sort()
          .join(contextTranslate(props.labelKeySeparatorMultiSelection, ', '))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.length, props.labelKeySeparatorMultiSelection, selectedItems, translate]);

  const handleClearInput = () => {
    if (Boolean(inputValue)) {
      setValue('');
      onClear();
    }
  };

  const handleInput = ($event) => {
    const inputValueSearch = $event.target.value;
    setValue(inputValueSearch);
    if (inputValueSearch === '') {
      onClear();
    }
    //onChange(inputValueSearch);
  };

  const getOptions = () => {
    const {
      searchOptions = {
        keys: ['label'],
        threshold: 0.2
      }
    } = props;
    const fuse = new Fuse(options, {
      ...searchOptions
    });
    if (Boolean(inputValue)) {
      return fuse.search(inputValue).map((e) => e.item);
    } else {
      return options;
    }
  };

  const result = getOptions().map((item, index) => {
    return renderItem(item, index === 0 && item.value === ITEM_ANY_ELEMENTS);
  });

  React.useEffect(() => {
    const newSelectedItemsState = selectedItemsState[travelInterestId]?.selectedItems;
    if (filterContainsPrepopulatedOptions(newSelectedItemsState)) {
      if (data && data[travelInterestId]) {
        const selectedOptions = updatePrepopulatedOptions({
          selectedItemsState: newSelectedItemsState,
          data,
          travelInterestId,
          itemAllEelements: ITEM_ALL_ELEMENTS
        });
        setSelectedItems(selectedOptions);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const mobile = (
    <FlexibleFilterContainer
      ref={flexibleFilterContainerRef}
      {...containerSettings}
      mobileView={customMobileScreenWidth?.length > 0 ? isMobile : undefined}
      saveOnClose={false}
      variant="layout.popover"
      label={title}
      title={title}
      footer={renderFooter()}
      onBackButtonPress={() => {
        if (inputValue !== '') {
          setValue('');
        }
      }}
      // disabledClearButton={budgetValue === null}
      // disabledDoneButton={budgetValue === null}
      onScroll={() => {}}
      //   enabledClearButton
      customAccessibilityToggleElement={true}
      //   labelBottomBtn={translate(doneButtonLabelKey, 'Done')}
      //   labelClearBtn={translate(clearButtonLabelKey, 'Clear')}
      // onClearBtn={() => {
      //   setBudget(null);
      //   setSave(null);
      //   props.onChange(null);
      //   budgetRef.current?.reset();
      // }}
      onDismiss={() => {
        if (Boolean(selectedItemsState[travelInterestId])) {
          const newSelectedItemsState = selectedItemsState[travelInterestId].selectedItems;
          if (filterContainsPrepopulatedOptions(newSelectedItemsState)) {
            if (data && data[travelInterestId]) {
              const selectedOptions = updatePrepopulatedOptions({
                selectedItemsState: newSelectedItemsState,
                data,
                travelInterestId,
                itemAllEelements: ITEM_ALL_ELEMENTS
              });
              setSelectedItems(selectedOptions);
            }
          } else {
            setSelectedItems(newSelectedItemsState);
          }
        } else {
          setSelectedItems([]);
        }
        setValue('');
        if (itemSelectedByKeyboard) {
          setItemSelectedByKeyboard(null);
        }
      }}
      // onOpenPopup={() => {
      //   setTimeout(() => budgetRef.current.focusedElement(), 700);

      //   if (value === null && save !== budgetValue && save === value) {
      //     budgetRef.current?.update(save);
      //     setBudget(save);
      //     setSave(null);
      //   } else if (value !== null && value !== budgetValue) {
      //     setBudget(value);
      //     budgetRef.current?.update(value);
      //   }
      // }}
      toggleElement={
        <FilterButton
          labelSeparator={contextTranslate(props.labelKeySeparatorMultiSelection)}
          {...props.inputItem}
          //   id={`toggleElementId-${id}`}
          value={buttonLabel}
          count
          active={active}
          // aria-label={`${label} ${
          //   value ? `${translate(`cmp-currency-${currency}`, currency)} ${value}` : ''
          // }`}
          // active={Boolean(value)}
          disabled={disabled} // used to disabled the component
          // onFocus={() => {
          //   if (flexibleRef.current.isOpen)
          //     timer = setTimeout(() => {
          //       flexibleRef.current.close();
          //     }, 150);
          // }}
          // onBlur={() => {
          //   clearTimeout(timer);
          // }}
        />
      }
      // onSave={() => {
      //   props.onChange(budgetValue);
      //   setSave(budgetValue);
      // }}
    >
      <Box {...menuContainer}>
        {options.length >= enableSearchQuantityItems && (
          <Input
            rightIcons={Boolean(inputValue) ? ['close-material'] : ['searchV2']}
            rightAriaLabel={Boolean(inputValue) ? ['Clear'] : ['Search']}
            rightTabIndex={Boolean(inputValue) ? [0] : [-1]}
            onRightIconClick={handleClearInput}
            placeholder={contextTranslate(
              'cmp-location-selector-secondary-search-placeholder',
              'Search'
            )}
            margin="2"
            marginTop="1"
            value={inputValue}
            autoComplete="off"
            {...props.secondarySearchSettings}
            onChange={handleInput}
          />
        )}
        <Box {...optionsContainer}>
          {result.length > 0 ? (
            result
          ) : (
            <LocationSelectorNoResult {...noResultItem}>
              {translate(noResultLabelKey, 'No result to show')}
            </LocationSelectorNoResult>
          )}
        </Box>
      </Box>
    </FlexibleFilterContainer>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>{isMobile ? mobile : desktop}</ThemeProvider>
    </EmotionCache>
  );
};

const TravelerInterest = React.forwardRef(TravelerInterestCmp);
export default TravelerInterest;
